
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import PicParticles from '@/utils/PicParticles'

import { CountUp } from 'countup.js'
import * as echarts from 'echarts'

import Circular from './Circular.vue'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    components: {
        Circular
    },
    props: ['canChange'],
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common

        const getParents = (node, name: string) => {
            const parent = node.parentNode
            if (!parent || !parent.className || parent.className.indexOf('.transport-list') > -1) return false
            if (parent.className.indexOf(name) > -1) {
                return true
            }
            getParents(parent, name)
        }

        const CountUpStart = (node) => {
            const num = node.innerText
            let options = {}
            if (num.indexOf('.') > -1) {
                options = {
                    useGrouping: false,
                    decimalPlaces: num.split('.')[1].length,
                    decimal: '.',
                }
            }
            const countUp = new CountUp(node, node.innerText, options)
            countUp.start()
        }

        const numCountUp = (node) => {
            const cs = node.querySelectorAll('.count-up')
            if (node.className.indexOf('count-up') > -1) {
                CountUpStart(node)
            }
            for (let i = 0; i < cs.length; i++) {
                CountUpStart(cs[i])
            }
        }

        const commonEvent = () => {
            const list = document.querySelector('.transport-wrapper .transport-list') as HTMLDivElement
            const ps = list.querySelectorAll('p, .line')
            for (let i = 0; i < ps.length; i++) {
                const p = ps[i] as HTMLParagraphElement
                let t = p.getBoundingClientRect().top - window.innerHeight / 2
                if (p.getBoundingClientRect().bottom - document.documentElement.scrollTop - p.getBoundingClientRect().bottom + document.documentElement.scrollTop <  window.innerHeight) {
                    t = p.getBoundingClientRect().bottom - window.innerHeight + window.innerWidth * .1
                }
                if (t <= 0) {
                    const cls = p.className
                    if (cls.indexOf('show') < 0) {
                        p.className += ' show'
                        numCountUp(p)
                    }
                }
            }
        }

        const scrollEvent = () => {
            commonEvent()
            echartInit()
        }

        const echartOptions = [
            {
                color: ['#fcc026', '#f49f22', '#ef8e25', '#ed8526', '#ea7c21', '#e86a23', '#e55f25', '#e05220', '#dd4a22', '#db3d23'],
                series: [
                    {
                        name: 'mileage',
                        type: 'pie',
                        radius: ['20%', '100%'],
                        center: ['50%', '50%'],
                        roseType: 'area',
                        itemStyle: {
                            borderRadius: 5
                        },
                        label: {
                            formatter: '{b}\n{c}万km',
                            position: 'inside',
                            fontFamily: 'TENSANS-BOLD',
                            fontSize: 10
                        },
                        labelLayout: {
                            hideOverlap: false // 是否隐藏重叠标签
                        },
                        data: [
                            { value: 2.18, name: '1949' },
                            { value: 3.23, name: '1959' },
                            { value: 4.17, name: '1969' },
                            { value: 5.30, name: '1979' },
                            { value: 5.70, name: '1989' },
                            { value: 6.74, name: '1999' },
                            { value: 8.55, name: '2009' },
                            { value: 13.99, name: '2019' },
                            { value: 15.90, name: '2023' },
                        ]
                    }
                ]
            }
        ]

        let myCharts: any[] = []
        const echartInit = () => {
            const echartsNodes = document.querySelectorAll('.transport-wrapper .echarts')
            for (let i = 0; i < echartsNodes.length; i++) {
                const node = echartsNodes[i] as HTMLDivElement
                !myCharts[i] && myCharts.push({
                    echart: echarts.init(node),
                    isLoad: false
                })
                if (node.getBoundingClientRect().top - window.innerHeight / 2 < 0 && !myCharts[i].isLoad) {
                    myCharts[i].echart.setOption(echartOptions[i])
                    myCharts[i].isLoad = true
                }
            }   
        }

        let titleParticles: any = null
        const titleEvent = () => {
            const title = document.querySelector('.transport-wrapper .title') as HTMLDivElement
            if (!titleParticles) {
                titleParticles = new PicParticles({
                    container: title,
                    imgUrl: require('../../assets/img/transport/title_color_bg.png'),
                    pix: 30,
                    radius: 60,
                    duration: 2000
                })
            }
        }
 
        const init = () => {
            titleEvent()
            scrollEvent()
            window.addEventListener('scroll', scrollEvent, false)
        }

        watch(() => props.canChange, (to, from) => {
            if (to) {
                init()
            }
        })

        onBeforeUnmount(() => {
            myCharts.forEach((e) => {
                if (e.echart != null && e.echart.dispose) {
                    e.echart.dispose()
                    e.echart = null
                }
            })
            if (titleParticles) {
                titleParticles.forceDestroy()
                titleParticles = null
            }
            window.removeEventListener('scroll', scrollEvent, false)
        })

        onMounted(() => {
            if(props.canChange) {
                init()
            }
        })    

        return {
            
        }
    }
})
